import { render, staticRenderFns } from "./EditBox.vue?vue&type=template&id=206541d4"
import script from "./EditBox.vue?vue&type=script&lang=js"
export * from "./EditBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports